/**
 * CONSTANTS FILE
 *
 * @version 0.1
 */

import DEFAULT_TRANSLATIONS from './../i18n/default.json';

export const DEVELOPMENT_ENVIRONMENT = true;

export const ALLOWED_FORMATTING_HTML = ['b', 'em', 'i', 'small', 'strong', 'sub', 'sup', 'ins', 'del', 'mark'];

export const RELEASE_BUILD_VERSION = '20_69'; // first number is the current year, second number is the sprint number

export const PI_NUMBER = 3.14159265359;

export const FILES_DIRECTORY = '/files/';
export const EMPTY_COMPANIES_XLSL = '/api/template/download-template';
export const EXISTING_COMPANIES_XLSL = FILES_DIRECTORY + 'Companies.xlsx';
export const WHATSNEW_TOOLTIP_ONSCREEN_TIME = 11000; //1 second accounting for fade-in/fadeout animations
export const AUDIT_REPORTS_PROGRESS_BAR_TOOLTIP_PERCENTAGE = 25;

export const FILTERS_DEBOUNCE_TIME = 1000;
export const SCROLL_DEBOUNCE_TIME = 300;
export const SCROLL_THROTTLE_TIME = 200;

export const MAX_EXCEL_UPLOAD_SIZE = 1000000;
export const POPUP_LIFETIME = 5000;
export const POPUP_INITIAL_DELAY = 500;
export const ADD_RSS_INPUT_CHAR_LIMIT = 40;
export const ADD_RSS_LABELS_LIMIT_PER_ROW = 4;
export const DEFATULT_TABLE_PAGE_SIZE = 50;
export const DASHBOARD_PODS_ENTRIES_NUMBER = 10;
export const DELIVERY_ICONS_EMAIL_ADDRESSES_ALLOWED = 10;
export const APPLIED_FILTERS_TOOLTIP_MAX_WIDTH = 500;

export const MAX_CATEGORY_NAME_LENGTH = 20;
export const PREVIEW_ARTICLE_UNLICENCED_CHAR_LIMIT = 200;

export const USER_SESSION_EXPIRY_TIME = 20 * 60 * 1000;

export const ANY_LEVEL = "ANY_LEVEL";
export const ANY_PESTLE = "ANY_PESTLE";

export const PESTLE_SELECT_OPTIONS = {
    'ANY_PESTLE':    'Entities_Preview_UIText_previewCompanies.selectOptionsPestle.allRiskAngles',
    'political':     'Entities_Preview_UIText_previewCompanies.selectOptionsPestle.political',
    'economic':      'Entities_Preview_UIText_previewCompanies.selectOptionsPestle.economic',
    'social':        'Entities_Preview_UIText_previewCompanies.selectOptionsPestle.social',
    'technological': 'Entities_Preview_UIText_previewCompanies.selectOptionsPestle.technological',
    'legal':         'Entities_Preview_UIText_previewCompanies.selectOptionsPestle.legal',
    'environmental': 'Entities_Preview_UIText_previewCompanies.selectOptionsPestle.environmental'
};

export const RISKS_SELECT_OPTIONS = {
    'ANY_LEVEL':   'Entities_Preview_UIText_previewCompanies.selectOptionsRisk.allRiskLevels',
    'high':        'Entities_Preview_UIText_previewCompanies.selectOptionsRisk.highOnly',
    'high_medium': 'Entities_Preview_UIText_previewCompanies.selectOptionsRisk.highMedium',
    'medium':      'Entities_Preview_UIText_previewCompanies.selectOptionsRisk.mediumOnly',
    'medium_low':  'Entities_Preview_UIText_previewCompanies.selectOptionsRisk.mediumLow',
    'low':         'Entities_Preview_UIText_previewCompanies.selectOptionsRisk.lowOnly'
};

export const ENTITIES_FILTER_CATEGORIES = "categories";
export const ENTITIES_FILTER_ALL_ENTITIES = "all_entities";
export const ENTITIES_FILTER_SPECIFIC = "specific";
export const EXPERIAN_ERROR = "Error";

export const CATEGORIES_ENTITIES_VISIBLE_COUNT = 20;
export const CATEGORIES_ENTITIES_VISIBLE_LABELS = 5;
export const ENTITY_CATEGORIES_VISIBLE_COUNT = 20;

export const SANCTION_TYPE_PEP = "Politically Exposed Persons (PEP)";
export const SANCTION_TYPE_PEP_ES = "Politically Exposed Persons";
export const SANCTION_TYPE_WATCHB = "Watchlists and Blacklists";
export const SANCTION_TYPE_SANLST = "National Financial Institutions Sanctions and Legal Actions";
export const SANCTION_TYPE_SANLST_SANCTIONS = "Sanctions";
export const SANCTION_TYPE_SANCTION_LISTS = "Sanction Lists";
export const SANCTION_TYPE_SANLST_TITLE = "Sanction";
export const SANCTION_TYPE_ES_EMBARGOS = "Autuações Ambientais e Embargos";
export const SANCTION_TYPE_ES_FRONTEIRA_INTERNATIONAL = "Municípios que tocam a fronteira internacional";

export const SANCTIONS_CISIDS = [
    { id: "314048", type: "Watchlists and Blacklists" },
    { id: "286191", type: "Sanction Lists" },
    { id: "286185", type: "Politically Exposed Persons (PEP)" },
    { id: "438717", type: "Municípios que tocam a fronteira internacional" },
    { id: "438716", type: "Autuações Ambientais e Embargos" }
]

export const FILTER_TYPE_DROPDOWN = "dropdown-filter";

export const GET = "GET";
export const POST = "POST";

export const OVERLAY_SIZES = {
    XS: "extra-small",
    S: "small",
    M: "medium",
    L: "large",
    XL: "extra-large"
}

export const SORT = {
    ASC: "asc",
    DESC: "desc",
    DEFAULT: "default"
}

// default SORT order for: Review & Activate Uploads / Manage Entities / Manage Categories / RSS Feeds / Manage Alerts
export const INACTIVE_ENTITIES_PAGE_SIZE = 50;
export const INACTIVE_ENTITIES_DEFAULT_SORT = {
    sortBy: "createdDate",
    direction: SORT.DESC
};
export const ENTITIES_PAGE_SIZE = 50;
export const ENTITIES_DEFAULT_SORT = {
    sortBy: "createdDate",
    direction: SORT.DESC
};
export const CATEGORIES_PAGE_SIZE = 50;
export const CATEGORIES_DEFAULT_SORT = {
    sortBy: "lastUpdated",
    direction: SORT.DESC
};
export const MANAGE_FEEDS_ENTITY_DISPLAY_LIMIT = 20;
export const MANAGE_FEEDS_DEFAULT_SORT = {
    sortBy: "lastUpdated",
    direction: SORT.DESC
};
export const ALERTS_PAGE_SIZE = 50;
export const ALERTS_DEFAULT_SORT = {
    sortBy: "createdDate",
    direction: SORT.DESC
};

export const USERS_PAGE_SIZE = 50;
export const USERS_DEFAULT_SORT = {
    sortBy: "lastUpdated",
    direction: SORT.DESC
};

// pages names, to be used in reduxStore as keys and in table headerItems object as persistableSort location
export const PAGE_NAME_REVIEW_AND_ACTIVATE = 'reviewAndActivateUploads';
export const PAGE_NAME_MANAGE_ENTITIES = 'manageEntities';
export const PAGE_NAME_MANAGE_CATEGORIES = 'manageCategories';
export const PAGE_NAME_MANAGE_FEEDS = 'manageFeeds';
export const PAGE_NAME_MANAGE_ALERTS = 'manageAlerts';

export const RSS_FEED_PAGE_SIZE = 100;
export const MANAGE_FEEDS_PAGE_SIZE = 50;
export const ENTITIES_HOT_UPDATE_LIMIT = 100;
export const SELECT_ALL_LIMIT = 5000;

// Help guide and Getting started guide links

export const GETTING_STARTED_LINK = 'userguidegetsartedtips-field?lbu=US&locale=en_US&audience=all';

export const DEFAULT_LANGUAGE = 'en-us';
export const LOCALES = {
    'en-us': {
        id: 'HeaderFooterNav_CoreFunctionality_Dropdown_nav.language.englishUs',
        locale: 'en-us',
        dbKey: 'en_us',
        translations: DEFAULT_TRANSLATIONS
    },
    'en-gb': {
        id: 'HeaderFooterNav_CoreFunctionality_Dropdown_nav.language.englishUk',
        locale: 'en-us',
        dbKey: 'en_gb',
        translations: {}
    },
    'fr': {
        id: 'HeaderFooterNav_CoreFunctionality_Dropdown_nav.language.french',
        locale: 'en-us',
        dbKey: 'fr',
        translations: {}
    },
    'de': {
        id: 'HeaderFooterNav_CoreFunctionality_Dropdown_nav.language.german',
        locale: 'en-us',
        dbKey: 'de',
        translations: {}
    }
};

export const LANGUAGE_SELECT_OPTIONS = {
    'all': 'General_CoreFunctionality_UIText_languageSelect.allLanguages',
    'en': 'General_CoreFunctionality_UIText_languageSelect.english',
    'fr': 'General_CoreFunctionality_UIText_languageSelect.french',
    'de': 'General_CoreFunctionality_UIText_languageSelect.german'
};

export const PESTLE_ORDER = [
    'political',
    'economic',
    'social',
    'technological',
    'legal',
    'environmental'
];

export const PESTLE_I18N_IDS = [
    'General_CoreFunctionality_UIText_general.political',
    'General_CoreFunctionality_UIText_general.economic',
    'General_CoreFunctionality_UIText_general.social',
    'General_CoreFunctionality_UIText_general.technological',
    'General_CoreFunctionality_UIText_general.legal',
    'General_CoreFunctionality_UIText_general.environmental'
];

export const GRAPHS_MIN_BAR_PERCENTAGE = 3;

export const GRAPHS_COLOR_SCHEME = [
    '#77b800',
    '#8f2b8c',
    '#009ddb',
    '#e98310',
    '#ed1c24',
    '#ffda00',
    '#b1d66d',
    '#bf86bd',
    '#f4c188',
    '#bcbec0',
    '#55bee7',
    '#939598',
    '#f4777c',
    '#ffee7f',
    '#d8ebb6',
    '#efe1ef',
    '#aadef3',
    '#fbead7',
    '#fbd2d3',
    '#fff9d4',
    '#e9e9ea'
];

export const PERCENTAGE_BARS_COLOR_SCHEME = [
    '#B2D9FA',
    '#176BCC',
    '#e98310',
    '#b1d66d',
    '#bf86bd'
];

//TODO: To be removed when we will have a definitive object structure and the endpoint working on the local environment.
export const entityData = {
    "iSearchResponse": {
        "name":         "Microsoft Corporation",
        "attributeMap": {
            "Zip":            "98052-6399",
            "Google+URL":     "plus.google.com/115684033096930245910",
            "Ticker":         "MSFT",
            "NumEmployees":   "114000",
            "E-mailAddress":  "msft@microsoft.com",
            "LinkedInURL":    "www.linkedin.com/company/microsoft",
            "CompanyType":    "Public - Parent",
            "City":           "Redmond",
            "TwitterURL":     "www.twitter.com/microsoft",
            "FacebookURL":    "www.facebok.com/microsoft",
            "PinterestURL":   "www.pinterest.com/microsoft",
            "YouTubeURL":     "www.youtube.com/microsoft",
            "StreetAddress":  "1 Microsoft Way",
            "FortuneRanking": "25",
            "State":          "Washington",
            "FaxNumber":      "(425) 936-7329",
            "WebAddress":     "www.microsoft.com",
            "PhoneNumber":    "(425) 882-8080",
            "Country":        "United States",
            "PrimaryNAICS":   "<primary_naics><primary_desc><![CDATA[Software Publishers]]></primary_desc><primary_num>511210</primary_num></primary_naics>",
            "PrimarySIC":     "<primary_sic><primary_desc><![CDATA[Prepackaged software]]></primary_desc><primary_num>7372</primary_num></primary_sic>"
        },
        "entityId":     "1040872"
    },
    "iDunsNumber":     "08-146-6849"
};


// Console settings
export const consoleSettings = {
    style: {
        sucess: [
            'background: green',
            'color: white',
            'display: block',
            'width: 100%',
            'text-align: center'
        ].join(';'),
        failure: [
            'background: red',
            'color: white',
            'width: 100%',
            'display: block',
            'text-align: center'
        ].join(';')
    }
}

// Experian Constants
export const experianPageSize = 10;
export const experianCountries = [
    {
        name: "United States",
        value: "United States"
    }
]

// US States
export const usStates = [
    { name: 'ALABAMA', abbreviation: 'AL'},
    { name: 'ALASKA', abbreviation: 'AK'},
    { name: 'AMERICAN SAMOA', abbreviation: 'AS'},
    { name: 'ARIZONA', abbreviation: 'AZ'},
    { name: 'ARKANSAS', abbreviation: 'AR'},
    { name: 'CALIFORNIA', abbreviation: 'CA'},
    { name: 'COLORADO', abbreviation: 'CO'},
    { name: 'CONNECTICUT', abbreviation: 'CT'},
    { name: 'DELAWARE', abbreviation: 'DE'},
    { name: 'DISTRICT OF COLUMBIA', abbreviation: 'DC'},
    { name: 'FEDERATED STATES OF MICRONESIA', abbreviation: 'FM'},
    { name: 'FLORIDA', abbreviation: 'FL'},
    { name: 'GEORGIA', abbreviation: 'GA'},
    { name: 'GUAM', abbreviation: 'GU'},
    { name: 'HAWAII', abbreviation: 'HI'},
    { name: 'IDAHO', abbreviation: 'ID'},
    { name: 'ILLINOIS', abbreviation: 'IL'},
    { name: 'INDIANA', abbreviation: 'IN'},
    { name: 'IOWA', abbreviation: 'IA'},
    { name: 'KANSAS', abbreviation: 'KS'},
    { name: 'KENTUCKY', abbreviation: 'KY'},
    { name: 'LOUISIANA', abbreviation: 'LA'},
    { name: 'MAINE', abbreviation: 'ME'},
    { name: 'MARSHALL ISLANDS', abbreviation: 'MH'},
    { name: 'MARYLAND', abbreviation: 'MD'},
    { name: 'MASSACHUSETTS', abbreviation: 'MA'},
    { name: 'MICHIGAN', abbreviation: 'MI'},
    { name: 'MINNESOTA', abbreviation: 'MN'},
    { name: 'MISSISSIPPI', abbreviation: 'MS'},
    { name: 'MISSOURI', abbreviation: 'MO'},
    { name: 'MONTANA', abbreviation: 'MT'},
    { name: 'NEBRASKA', abbreviation: 'NE'},
    { name: 'NEVADA', abbreviation: 'NV'},
    { name: 'NEW HAMPSHIRE', abbreviation: 'NH'},
    { name: 'NEW JERSEY', abbreviation: 'NJ'},
    { name: 'NEW MEXICO', abbreviation: 'NM'},
    { name: 'NEW YORK', abbreviation: 'NY'},
    { name: 'NORTH CAROLINA', abbreviation: 'NC'},
    { name: 'NORTH DAKOTA', abbreviation: 'ND'},
    { name: 'NORTHERN MARIANA ISLANDS', abbreviation: 'MP'},
    { name: 'OHIO', abbreviation: 'OH'},
    { name: 'OKLAHOMA', abbreviation: 'OK'},
    { name: 'OREGON', abbreviation: 'OR'},
    { name: 'PALAU', abbreviation: 'PW'},
    { name: 'PENNSYLVANIA', abbreviation: 'PA'},
    { name: 'PUERTO RICO', abbreviation: 'PR'},
    { name: 'RHODE ISLAND', abbreviation: 'RI'},
    { name: 'SOUTH CAROLINA', abbreviation: 'SC'},
    { name: 'SOUTH DAKOTA', abbreviation: 'SD'},
    { name: 'TENNESSEE', abbreviation: 'TN'},
    { name: 'TEXAS', abbreviation: 'TX'},
    { name: 'UTAH', abbreviation: 'UT'},
    { name: 'VERMONT', abbreviation: 'VT'},
    { name: 'VIRGIN ISLANDS', abbreviation: 'VI'},
    { name: 'VIRGINIA', abbreviation: 'VA'},
    { name: 'WASHINGTON', abbreviation: 'WA'},
    { name: 'WEST VIRGINIA', abbreviation: 'WV'},
    { name: 'WISCONSIN', abbreviation: 'WI'},
    { name: 'WYOMING', abbreviation: 'WY' }
];

export const EXPERIAN_RISK_VERY_HIGH = 'VERY_HIGH_RISK';
export const EXPERIAN_RISK_HIGH = 'HIGH_RISK';
export const EXPERIAN_RISK_MEDIUM_HIGH = 'MEDIUM_HIGH_RISK';
export const EXPERIAN_RISK_MEDIUM = 'MEDIUM_RISK';
export const EXPERIAN_RISK_LOW_MEDIUM = 'LOW_MEDIUM_RISK';
export const EXPERIAN_RISK_LOW = 'LOW_RISK';

export const EXPERIAN_DEFAULT_SLIDER_LEVEL_STABILITY_RISK = 2;
export const EXPERIAN_DEFAULT_SLIDER_LEVEL_DELINQUENCY_RISK = 1;

export const EXPERIAN_DELINQUENCY_STRINGS = [
    EXPERIAN_RISK_VERY_HIGH,
    EXPERIAN_RISK_HIGH,
    EXPERIAN_RISK_MEDIUM_HIGH,
    EXPERIAN_RISK_MEDIUM,
    EXPERIAN_RISK_LOW_MEDIUM,
    EXPERIAN_RISK_LOW
];

export const EXPERIAN_STABILITY_STRINGS = [
    EXPERIAN_RISK_HIGH,
    EXPERIAN_RISK_MEDIUM_HIGH,
    EXPERIAN_RISK_MEDIUM,
    EXPERIAN_RISK_LOW_MEDIUM,
    EXPERIAN_RISK_LOW
];

export const VALIDATION_ICON_VALID = 'isValid';
export const VALIDATION_ICON_INVALID = 'isInvalid';
export const VALIDATION_ICON_LOADING = 'isLoading';

export const CATEGORY_DELETION_LINKED_MAX_COUNT = 40;
export const LINK_TYPE_FEED = "feed";
export const LINK_TYPE_ALERT = "alert";
export const EXPERIAN_VALIDATION_VALID = 'isValid';
export const EXPERIAN_VALIDATION_INVALID = 'isInvalid';
export const EXPERIAN_VALIDATION_LOADING = 'isLoading';

export const SECTION_ALL_ENTITIES = "all-third-parties-section";
export const SECTION_CATEGORIES = "categories-section";
export const SECTION_ENTITIES = "specific-third-parties-section"

export const PERSISTED_FILTERS_MAP = {
    filtersEntireSection: 'isDashboardFiltersCollapsed',
    filtersNarrowBy: 'isDashboardFiltersNarrowByCollapsed',
    filtersEntities: 'isDashboardFiltersEntitiesCollapsed',
    filtersRiskAngles: 'isDashboardFiltersRiskAnglesCollapsed',
    filtersRiskLevels: 'isDashboardFiltersRiskLevelsCollapsed',
    filtersExperianCreditRating: 'isDashboardFiltersExperianCreditRatingCollapsed',
    filtersSanctionsAndWatchlist: 'isDashboardFiltersSanctionsAndWatchlistCollapsed',
    filtersDateRange: 'isDashboardFiltersDateRangeCollapsed',
    filtersLanguage: 'isDashboardFiltersLanguageCollapsed'
}

export const LS_KEY_PERSISTED_ENTITY_FILTERS    = (companyId) => (`persisted_entity_filters_${companyId}`);
export const LS_KEY_PERSISTED_ENTITY_PREFS      = (companyId) => (`persisted_entity_prefs_${companyId}`);

export const VISIBLE_RISK_PERSPECTIVES = ["company"];

export const APP_LANGUAGES = ["en", "de", "fr"];

export const UM_ERROR_TYPES = {
    missingCustomer: "UM_MISSING_CUSTOMER",
    missingData: "UM_MISSING_DATA",
    authTypeNotAllowed: "UM_AUTH_TYPE_NOT_ALLOWED",
    invalidLna2: "UM_INVALID_LNA2"
};

export const ENTITIES_DOWNLOAD_OPTIONS = {
    ALL_ENTITIES: 'all_entities',
    SELECTED_ENTITIES: 'selected_entities'
};

export const ENTITIES_DOWNLOAD_REPORT_ENDPOINT = "/api/entities/download/entities-report";

export const BOTTOM_DISTANCE = 13;

export const DASHBOARD_EXPORT_OPTIONS = {
    CURRENT_VIEW: 'current_view',
    ALL_DATA: 'all_data'
};

export const MICROSOFT_EXCEL_FORMAT = "excel";

export const BACKGROUND_MESSAGE_TYPE = {
    DOWNLOAD: "download",
    SUCCESS: "success",
    ERROR: "error",
    PROCESSING: "processing",
};

export const BUILD_STATUS = {
    FINISHED: "FINISHED",
    STARTED: "STARTED",
    PROCESSING: "PROCESSING",
    ERROR: "ERROR",
};

export const DOWNLOAD_DOCUMENT_TYPE = {
    DASHBOARD: "DASHBOARD"
};

export const POLLING_TIMEOUT = 2500;


// WEBPACK FOOTER //
// ./src/scripts/constants.js